// import { createSelector } from '@reduxjs/toolkit';
import { ConfigState } from '../types/config.type';

interface RootState {
    config: ConfigState;
}

export const selectConfigState = (state: RootState) => state.config;
